import { toDataURL } from 'qrcode'
import { useEffect, useState, type ReactNode } from 'react'

/**
 * O QR do Pix, desenhado a partir do copia-e-cola — F204/F207.
 *
 * A Monedd devolve `url: null`: o QR não vem pronto. O desenho é local, sem
 * serviço de terceiro que veria o código do Pix passar.
 */
export const PixQr = ({
  text,
  size = 220,
  alt = 'QR Code do Pix',
}: {
  text: string
  size?: number
  /** O ponto (F339) usa o mesmo desenho para o link do aparelho. */
  alt?: string
}): ReactNode => {
  const [src, setSrc] = useState<string | null>(null)
  useEffect(() => {
    let alive = true
    toDataURL(text, { margin: 1, width: size })
      .then((url) => {
        if (alive) setSrc(url)
      })
      .catch(() => {
        if (alive) setSrc(null)
      })
    return () => {
      alive = false
    }
  }, [text, size])
  return src === null ? null : (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      className="self-center rounded-(--radius-sm) bg-white"
    />
  )
}
